import ApiRequest from "../index"

const categoriasNovaRequest = {
    getCategoriasNova: async data => ApiRequest.get(`/v2/lojinha/category/main/list`),
    putCategoriasUpdate: async data => ApiRequest.put(`/v2/lojinha/category/main/update`, {...data}), 
    deleteCategoriaDelete: async id => ApiRequest.delete(`/v2/lojinha/category/main/delete/${id}`),
    postCategoriasCreate: async body => ApiRequest.post(`/v2/lojinha/category/main/create`, {...body}),
}

export default categoriasNovaRequest